import { useEffect, useRef, useCallback } from 'react';
import { useRouter } from 'next/router';
import { analyticsClient } from 'sdks/analytics';
import { RouteToAnalyticsScreenMap, EventField } from 'sdks/analytics/types';
import { useAuth } from 'hooks/useAuth';

export const useAnalyticsRouteTracking = () => {
  const router = useRouter();
  const { isProfileLoading, isLoading } = useAuth();
  const hasTrackedInitialRoute = useRef(false);
  const listenerSetup = useRef(false);

  const trackRoute = useCallback((url: string) => {
    const [pathname, queryString] = url.split('?');
    const screenName = RouteToAnalyticsScreenMap[pathname] || pathname;
    analyticsClient.updateScreenNameOnly(screenName);

    const eventData = queryString
      ? { [EventField.F1]: queryString }
      : {};

    analyticsClient.logScreenView(eventData);
  }, []);

  useEffect(() => {
    analyticsClient.init();

    if (!listenerSetup.current) {
      router.events.on('routeChangeComplete', trackRoute);
      listenerSetup.current = true;
    }

    return () => {
      if (listenerSetup.current) {
        router.events.off('routeChangeComplete', trackRoute);
        listenerSetup.current = false;
      }
    };
  }, [router, trackRoute]);

  useEffect(() => {
    if (hasTrackedInitialRoute.current) {
      return;
    }

    if ((isProfileLoading || isLoading) && router.asPath !== '/') {
      return;
    }

    trackRoute(router.asPath);
    hasTrackedInitialRoute.current = true;
  }, [isProfileLoading, router.asPath, trackRoute, isLoading]);
};

